import React, { forwardRef } from 'react';

import style from './index.module.scss';

import clsx from 'clsx';
import { Button, ButtonProps } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
interface Props extends Omit<ButtonProps, 'ref'> {}

export const MeetingSlotCreate = forwardRef<HTMLButtonElement, Props>(
  ({ className, ...rest }, ref) => {
    return (
      <Button ref={ref} variant={'contained'} {...rest} className={clsx(style.root, className)}>
        <AddIcon />
      </Button>
    );
  },
);
